export default {
  LABEL: 'label',
  PLACEHOLDER: 'placeholder',
  OPTIONS: 'options',
  BUTTON_TEXT: 'buttonText',
  FILE_TYPE: 'fileType',
  NUMBER_OF_FILES: 'numberOfFiles',
  TIME_FORMAT: 'timeFormat',
  REQUIRED: 'required',
};
